<template>
      <div class="services-page-container">
            <AlignmentSpecialist />
            <CosmeticDentistry class="hidden"/>
            <OralHygieneExperts class="hidden"/>
            <RootCanalSpecialist class="hidden"/>
            <ModerneTechnologie class="hidden"/>
            <LiveDentalAdvisory class="hidden"/>
            <CavityInspection class="hidden"/>

      </div>
</template>

<script>
import AlignmentSpecialist from '../components/AlignmentSpecialist.vue';
import CosmeticDentistry from '../components/CosmeticDentistry.vue';
import OralHygieneExperts from '../components/OralHygieneExperts.vue';
import RootCanalSpecialist from '../components/RootCanalSpecialist.vue';
import ModerneTechnologie from '../components/ModerneTechnologie.vue';
import LiveDentalAdvisory from '../components/LiveDentalAdvisory.vue';
import CavityInspection from '../components/CavityInspection.vue';



export default {
name: "Services",
components: {
    AlignmentSpecialist,
    CosmeticDentistry,
    OralHygieneExperts,
    RootCanalSpecialist,
    ModerneTechnologie,
    LiveDentalAdvisory,
    CavityInspection  
},
mounted(){
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Tandheelkundige Diensten | Tandzorg Gestel | Behandelingen Sint-Michielsgestel"
      document.querySelector('meta[name="description"]').setAttribute("content", "Complete tandheelkundige zorg: controles, vullingen, wortelkanaalbehandelingen, cosmetische tandheelkunde en meer bij Tandzorg Gestel.");
      this.$store.commit('updateActivePage', 'Services')

    if(this.$store.state.activePage != "Services") {

      if(this.$store.state.scrollToServicesSection == 'alignment-specialist') {
        const element = document.getElementById('alignment-specialist');

        element.scrollIntoView({ behavior: 'smooth' });
      }
      else if(this.$store.state.scrollToServicesSection == 'header-nav') {
        const element = document.getElementById('header-nav');

        element.scrollIntoView({ behavior: 'smooth' });
      }
      else if(this.$store.state.scrollToServicesSection == 'cosmetic-dentistry') {
        const element = document.getElementById('cosmetic-dentistry');

        element.scrollIntoView({ behavior: 'smooth' });
      }
      else if(this.$store.state.scrollToServicesSection == 'oral-hygiene-experts') {
        const element = document.getElementById('oral-hygiene-experts');

        element.scrollIntoView({ behavior: 'smooth' });
      }
      else if(this.$store.state.scrollToServicesSection == 'root-canal-specialist') {
        const element = document.getElementById('root-canal-specialist');

        element.scrollIntoView({ behavior: 'smooth' });
      }
      else if(this.$store.state.scrollToServicesSection == 'live-dental-advisory') {
        const element = document.getElementById('live-dental-advisory');

        element.scrollIntoView({ behavior: 'smooth' });
      }
      else if(this.$store.state.scrollToServicesSection == 'cavity-inspection') {
        const element = document.getElementById('cavity-inspection');

        element.scrollIntoView({ behavior: 'smooth' });
      } 


    }

      this.$store.commit('updateActivePage', 'Services')  

    }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateX(0);
}

.services-page-container {
  margin-top: 88px;
}

.team-col {
    flex-basis: 48%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}
.row-custom:not(:first-child) {
    /* margin-top:60px; */
}
.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}



.alignment-specialist-container, .oral-hygiene-experts-container, .live-dental-advisory-container {
    background-color: #F2F2F2;
}


@media(max-width: 991px) {
    .services-page-container {
        margin-top: 63px;
    }
    .row-custom:not(:first-child) {
        /* margin-top:30px; */
    }
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
    }
    #facings-techniques-img {
        height: 200px;
    }
    .tech-image {
        height: 200px !important;
    }
    .reverse {
        flex-direction: column-reverse;
    }

}

@media (max-width: 450px) {
    .services-page-container {
        margin-top: 55px;
    }
}
</style>